import { render, staticRenderFns } from "./StrategyDialog.vue?vue&type=template&id=6d4d53f6"
import script from "./StrategyDialog.vue?vue&type=script&lang=js"
export * from "./StrategyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports